<template>
  <Modal :id="id" title="Edit Registration" :hideClose="true">
    <div slot="body" class="modal-body modal-form"></div>
    <div slot="footer" class="modal-footer">
      <a class="btn btn-success" href="#" @click.prevent="save">Save</a>
      <a class="btn btn-info" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "edit-enrollment-form-modal",
      enrollment: null,
    };
  },
  methods: {
    save() {
      var url = this.route("enroll.classroom.cart.form", {
        enrollment: this.enrollment.id,
      });
      this.axios.post(url, {}).then(() => {
        this.resolve();
      });
    },
  },
  created() {
    this.enrollment = _.cloneDeep(this.options.enrollment);
  },
};
</script>